module.exports = __webpack_public_path__ + "img/icon_xiangmu.8d6595de.svg";